import axios from 'axios';
import config from '../config';
import {sessionID} from './../../utils/handlingSession'
import {userLogs} from './../logs/userLogs'

export const forgotPassword = async (formData) => {
    let url = config.hummBackendAppURL+'user/forgot-password'

   return axios.post(url, formData,{headers:sessionID()}).then(res => {
        return res;
    })
    .catch( err => {
        userLogs(url,formData,err)
        return err.response
    })


};